import { Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { EnpsSubscriber } from '@common/utils/enps-subscriber';
import { Subscription } from 'rxjs';

@Directive({})
export class EnpsDirective extends EnpsSubscriber implements OnDestroy {
    @Input() public isNewRecord: boolean = false;

    public loading: boolean = false;
    public loaderTimeout;

    public static visualStatesCollection: { [id: string]: unknown } = {};

    public get visualState(): unknown {
        if (this._id) {
            if (!EnpsDirective.visualStatesCollection[this._id]) {
                EnpsDirective.visualStatesCollection[this._id] = {};
            }
            return EnpsDirective.visualStatesCollection[this._id];
        }
        return null;
    }

    public set visualState(s: unknown) {
        if (this._id) {
            EnpsDirective.visualStatesCollection[this._id] = s;
        }
    }

    private _id: string = null;
    @Input()
    public get id(): string {
        return this._id;
    }
    public set id(v: string) {
        if (this._id) {
            delete EnpsDirective.visualStatesCollection[this._id];
        }

        this._id = v;
        if (this._id && !EnpsDirective.visualStatesCollection[this._id]) {
            EnpsDirective.visualStatesCollection[this._id] = {};
        }
    }

    private __required: boolean;
    @Input()
    public get required(): boolean {
        return this.__required;
    }
    public set required(v: boolean) {
        this.__required = v;
    }

    ngOnDestroy() {
        this.removeAllSubscriptions();
        for (const p of Object.keys(this)) {
            if (this[p] instanceof Subscription || this[p] instanceof EnpsDirective || this[p] instanceof ElementRef) {
                // console.log("set " + this.constructor.name + "." + p + " to null");
                this[p] = null;
            }
        }
        this.subscriptions = new Subscription();
    }
}
